// FormList.jsx - Modüler yapıya yönlendirme dosyası
import FormListModular from './FormListModular';

// Geriye uyumluluk için orijinal FormList bileşenini export et

export default FormListModular;